import { useAtomValue } from 'jotai';
import { shopCodeAtom } from '@/atoms';

export const useShopCode = () => {
  const shopCode = useAtomValue(shopCodeAtom);

  return { shopCode };
};
